import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface IDoNotKnowPriceSellStep_3 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSellStep_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSellStep_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_2);
    onReset(["timeIntervalTypeCommunication"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_4);
  };

  const handleChange = (
    data: string,
    key: "timeIntervalTypeView" | "timeIntervalTypeCommunication"
  ) => {
    if(key === "timeIntervalTypeCommunication"){
      onChange(data, key);
    }
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={handleChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="communication"
        text="Удобное время для связи:"
      />
    </div>
  );
};

export default DoNotKnowPriceSellStep_3;
